export const hideOrderModuleForExperiment = () => {
  const orderUrlMeta = document.querySelector('meta[name="orderUrl"]');
  let orderUrlValue = orderUrlMeta
    ? orderUrlMeta.getAttribute('content').trim()
    : '';

  // Add or append the query string 'pemid=mini'
  if (orderUrlValue) {
    const url = new URL(orderUrlValue, window.location.origin);
    url.searchParams.set('pemid', 'mini');
    orderUrlValue = url.toString();
  }

  const orderTextMeta = document.querySelector('meta[name="orderButtonText"]')
  const orderTextValue = orderTextMeta
    ? orderTextMeta.getAttribute('content').trim()
    : 'Order food online'

  const addToBasketButtons = document.querySelectorAll('.addtobasket');
  addToBasketButtons.forEach(el => {
    el.style.pointerEvents = 'none';
  });

  // Remove the '+' content from .product-order-button::before and ::after
  const style = document.createElement('style');
  style.innerHTML = `
    .product-order-button::before,
    .product-order-button::after {
      content: none !important;
    }
  `;
document.head.appendChild(style);

  // Select the div by its class name
  const basketDiv = document.querySelector('.staticBasket')

  // Empty the div
  if (basketDiv) {
    basketDiv.innerHTML = '' // Remove all child elements and content
  }

  // Insert the HTML into the div
  if (basketDiv) {
    basketDiv.innerHTML = `
    <div class="main-basket">
        <div class="basket-container">
            <section class="cartbutton">
                <a class="btn-order-online" href="${orderUrlValue}" rel="nofollow">
                    ${orderTextValue}
                </a>
            </section>
        </div>
        </div>
    `
  } 
}
